import projecCategoryEpicsMap from "./projectCategory.epics";
import * as projectCategoryReducers from "./projectCategory.reducers";
import { objectValues } from "@ea/shared_components/utils/object";

const projectCategoryEpics = objectValues(projecCategoryEpicsMap);

export { projectCategoryReducers, projectCategoryEpics };
